import * as React from 'react';
import cx from 'classnames';
import { TextInput, } from '@dropbox/dig-components/text_fields';
import { UIIcon } from '@dropbox/dig-icons';
import { SearchLine, CloseLine } from '@dropbox/dig-icons/assets';
import { IconButton } from '@dropbox/dig-components/buttons';
/**
 * Search is a standardized entrypoint for 'search' actions.
 *
 */
export const Search = ({ ariaLabels, chips, containerProps, disabled, onSubmit, onContainerBlur, onContainerFocus, onCloseButtonClick, onCloseButtonKeyPress, inputProps, inputBoxRef, inputContainerRef, hasExpandableAnimation = false, isActive, isInvalid, }) => {
    const [isControlledComponent] = React.useState(typeof isActive === 'boolean');
    const [_isActive, setIsActive] = React.useState(isControlledComponent ? isActive : false);
    const _handleFocus = () => {
        if (!isControlledComponent)
            setIsActive(true);
        if (onContainerFocus)
            onContainerFocus();
    };
    const _handleBlur = () => {
        if (!isControlledComponent)
            setIsActive(false);
        if (onContainerBlur)
            onContainerBlur();
    };
    const _handleSearchExit = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (inputBoxRef && inputBoxRef.current) {
            inputBoxRef.current.blur();
        }
        if (onCloseButtonClick)
            onCloseButtonClick();
    };
    const _handleCloseButtonKeyPress = (e) => {
        e.preventDefault();
        if (inputBoxRef && inputBoxRef.current) {
            inputBoxRef.current.blur();
        }
        if (onCloseButtonKeyPress)
            onCloseButtonKeyPress(e);
    };
    const _handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
            onSubmit();
        }
    };
    React.useEffect(() => {
        if (isControlledComponent)
            setIsActive(isActive);
    }, [isActive, isControlledComponent]);
    // In order to remain backwards compatible we need to keep inputProps working
    const _inputProps = {
        ...inputProps,
        disabled: disabled || inputProps.disabled,
    };
    return (React.createElement("div", { ...containerProps, className: cx('dpc-GlobalHeader-Search', {
            'dpc-GlobalHeader-Search--active': _isActive,
            'dpc-GlobalHeader-Search--expandable': hasExpandableAnimation,
        }), onBlur: _handleBlur, onFocus: _handleFocus, "aria-expanded": _isActive },
        React.createElement("form", { onSubmit: _handleSubmit, key: "search__form", className: "dpc-GlobalHeader-Search__form" },
            React.createElement(TextInput.Container, { className: "dpc-GlobalHeader-Search__container", disabled: disabled, isInvalid: isInvalid, ref: inputContainerRef },
                React.createElement(TextInput.Accessory, null,
                    React.createElement(UIIcon, { src: SearchLine })),
                !!chips && chips,
                React.createElement(TextInput.Input, { ..._inputProps, className: "dpc-GlobalHeader-Search__input", ref: inputBoxRef, "aria-label": ariaLabels && ariaLabels.input }),
                React.createElement(TextInput.Accessory, null,
                    React.createElement(IconButton, { variant: "transparent", onClick: _handleSearchExit, onKeyPress: _handleCloseButtonKeyPress, type: "button", size: "small", "aria-label": ariaLabels && ariaLabels.closeIcon, className: "dpc-GlobalHeader-Search__exit-btn" },
                        React.createElement(UIIcon, { src: CloseLine })))))));
};
Search.displayName = 'Search';
